import './Header.css'

const Header = () =>
{
	
	return (
		<div className="header-main-container" >
            <a href={`${process.env.REACT_APP_SITE_URL}`}> <img className='header-logo' src='	https://www.digitalreti.com/wp-content/uploads/2021/05/logo.png' alt='logo'></img> </a>
            <div className='header-links-container'>
                <a href={`${process.env.REACT_APP_SITE_URL}`} className='header-link'>Home Page</a>
                <a href={`${process.env.REACT_APP_SITE_URL}/chi-siamo/`} className='header-link'>Chi siamo</a>
                <a href={`${process.env.REACT_APP_SITE_URL}/servizi/`} className='header-link'>Servizi</a>
                <a href={`${process.env.REACT_APP_SITE_URL}/contatti/`} className='header-link'>Contatti</a>
            </div>
		</div>
	)
}

export default Header
